<template>
  <validation-observer
    v-if="isOutboundShown"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="outbound"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row
        :label="outboundConsentText.title"
      >
        <form-section-question slot="question">
          <span
            class="mr-1"
            v-html="outboundConsentText.subtitle"
          />
          <qz-tooltip
            v-if="outboundConsentText.helpText"
            left
          >
            <template #tooltip-body>
              <span
                v-html="outboundConsentText.helpText"
              />
            </template>
          </qz-tooltip>
        </form-section-question>
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_outbound`"
          name="Outbound"
          rules="required"
          class="controls-wrapper"
        >
          <radio
            v-model="questionData.outbound"
            :wide="isColumnLayout"
            :name="`${stepId}-outbound`"
            :data-test="snakeCase(questionFields.outbound)"
            :items="constants.YES_NO"
            :error="failed"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';
import QzTooltip from '@/components/QzTooltip/QzTooltip';
import pluralize from 'pluralize';

export default {
  name: 'question-outbound',
  extends: QuestionBase,
  components: { QzTooltip },
  props: {
    providersQty: {
      type: Number,
      default: 3,
    },
  },
  inject: ['productName', 'config'],
  data () {
    return {
      fields: ['outbound'],
    };
  },
  computed: {
    isOutboundShown () {
      // TODO: Still need two variables because of BE limitations. Sync with BE about possibility of using only one variable.
      return !this.config.hideOutboundConsent || !this.config.hidePartnerOutboundConsent;
    },
    outboundConsentText () {
      return { ...this.config.outboundConsentText };
    },
  },
  setup () {
    return { pluralize };
  },
};
</script>

<style lang="scss" scoped>
.row-wrapper {
  &::v-deep {
    .form-row__label {
      display: flex;
      align-items: baseline;
      justify-content: space-between;

      @media screen and (max-width: 767px) {
        display: block;

        .form-section-label {
          margin-bottom: 12px;
        }
      }
    }

    .form-section-label,
    .controls-wrapper {
      width: calc(50% - 12px);

      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
  }
}
</style>
